/* global Backbone */
'use strict';

import Log from 'lib/log';
import loader from 'helpers/loader';
import template from '../templates/bulkUpload/Main.ejs';
import jobStatusTemplate from '../templates/bulkUpload/JobStatus.ejs';
import Alerts from 'lib/alerts';
import BulkUpload from 'newModels/bulk-upload.js';

const log = Log('employees/bulk-upload');

module.exports = Backbone.View.extend({
    events: {
        'change input[type="file"]': 'selectFile',
        'click .js-action-1': 'uploadFile'
    },

    render: function() {
        this.$el.html(template({
            model: this.model || false,
        }));
        this.$('.js-action-1').prop('disabled', true);

        if (this.model && this.model.get('state') !== 'done') {
            this.renderJobStatus();
        }
        return this;
    },

    selectFile: function(e) {
        const files = [...this.$(e.currentTarget)[0].files];

        if (files.length === 0) {
            return;
        }

        const file = files.shift();
        const ext = file.name.split('.').pop();

        if (!ext.match(/^(xls|xlsx)$/i)) {
            return Alerts.show('error', {
                title: 'Wrong file type',
                text: 'Please choose an Excel file'
            });
        }

        this.$('.js-action-1').prop('disabled', false);
        this._file = file;
        this.$('.js-file-name').text(this._file.name);
        if (this.$result) {
            this.$result.fadeOut(50, () => {
                this.$('.js-result').html('');
            });
        }
    },

    uploadFile: function() {
        this.$('.js-file-btn').prop('disabled', true);

        const stopLoader = loader.startFullScreen(this.$('.js-action-1'));
        const file = this._file;
        const originalName = file.name;
        const ext = originalName.split('.').pop();

        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = ev => {
                const base64 = ev.target.result.split(',')[1];
                this.model = new BulkUpload({
                    file: {
                        name: `spreadsheet.${ext}`,
                        content: base64
                    },
                    companyId: app.company.id
                });
                return resolve(true);
            };
            reader.onerror = err => reject(err);
            reader.readAsDataURL(file);
        }).then(
            () => this.model.save()
        ).then(() => {
            this.render();
        }).finally(stopLoader);
    },

    renderJobStatus: function() {
        if (!this.model) {
            this.$('.js-status').html('');
            return;
        }

        this.renderJobStatusTemplate();

        const refresh = () => {
            if (!this.model || this.model.get('state') === 'done') {
                return app.company.fetch()
                    .catch(log.error)
                    .finally(() => {
                        this.render();
                        this.renderJobStatusTemplate();
                    });
            }

            setTimeout(() => this.model.fetch().then(() => {
                this.renderJobStatusTemplate();
                refresh();
            }), 2000);
        };
        refresh();
    },

    renderJobStatusTemplate: function() {
        this.$('.js-status').html(
            jobStatusTemplate({model: this.model})
        );
    }
});



// WEBPACK FOOTER //
// ./app/employer/views/EmployeesBulkUpload.js